module.exports = __webpack_public_path__ + "static/media/icon_2.1f4a974e.svg";